import { useLocation, matchPath } from 'react-router-dom';

import { NAVIGATION, SUB_NAVIGATION } from '../../../../constants/navigation';

export default function useNavLinks() {
  const { pathname } = useLocation();

  // First check if the current route matches any sub-navigation routes
  const subNavRoutes = Object.keys(SUB_NAVIGATION);

  const subNavMatch = subNavRoutes.find((route) => matchPath(route, pathname));

  if (subNavMatch) {
    console.log('subNavMatch', subNavMatch);
    return SUB_NAVIGATION[subNavMatch];
  }

  // Remove any leading/trailing slashes and split the path into segments
  const segments = pathname.replace(/^\/|\/$/g, '').split('/');
  // Return the first segment as the root route (if it exists)

  const rootRoute = segments[0] || '';

  return NAVIGATION[rootRoute] || [];
}
